module.exports = __webpack_public_path__ + "img/sec2.4.a6665336.png";